import React from 'react';
import { Badge } from '@/components/ui/badge';

export const JW_STATUS = {
  REQUESTED: { label: 'Waiting for Greige Storage', cls: 'bg-amber-100 text-amber-800' },
  PICKING: { label: 'Picking in Greige Storage', cls: 'bg-orange-100 text-orange-800' },
  TRANSFERRED: { label: 'Transferred · awaiting Gate Outward', cls: 'bg-sky-100 text-sky-800' },
  AT_JOBBER: { label: 'At jobber', cls: 'bg-indigo-100 text-indigo-800' },
  RECEIVING: { label: 'Receiving packs', cls: 'bg-teal-100 text-teal-800' },
  COMPLETED: { label: 'Closed', cls: 'bg-emerald-100 text-emerald-800' },
  REJECTED: { label: 'Rejected', cls: 'bg-rose-100 text-rose-800' },
  CANCELLED: { label: 'Cancelled', cls: 'bg-gray-100 text-gray-600' },
};

export const JwStatusBadge = ({ status, testId }) => {
  const s = JW_STATUS[status] || { label: status, cls: 'bg-gray-100 text-gray-700' };
  return <Badge className={`${s.cls} border-0 font-medium whitespace-nowrap`} data-testid={testId}>{s.label}</Badge>;
};

export const fmtDate = (iso) => (iso ? new Date(iso).toLocaleString('en-IN', { day: '2-digit', month: 'short', hour: '2-digit', minute: '2-digit' }) : '—');

export const sortSummary = (o) => (o.lines || []).map((l) => `${l.sort_no} × ${l.requested_pcs}`).join(', ');
